<p-table
  #dataTable
  aria-label="DMEPOS Product Cases Table"
  currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
  dataKey="authorizationCaseId"
  paginatorDropdownAppendTo="body"
  responsiveLayout="scroll"
  sortField="caseNumber"
  [alwaysShowPaginator]="true"
  [columns]="columnConfig"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]"
  [scrollable]="true"
  [selection]="selection"
  [selectionMode]="multiselect ? 'multiple' : 'single'"
  [showCurrentPageReport]="true"
  [value]="tableData"
  (selectionChange)="selectionChange($event)"
  >
  <ng-template let-columns pTemplate="header">
    <tr>
      @if (multiselect) {
        <th
          class="flex items-center justify-center"
          style="width: 3.5rem"
          >
          <p-tableHeaderCheckbox />
        </th>
      }
      @for (col of columns; track col.field) {
        <th
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.isSortable"
          [style]="col.styles"
          >
          <div class="flex items-center">
            {{ col.header }}
            @if (col.isSortable) {
              <p-sortIcon [field]="col.field" />
            }
          </div>
        </th>
      }
    </tr>
    @if (filterable) {
      <tr>
        <th style="width: 3.5rem"></th>
        @for (col of columns; track col.field) {
          <th>
            @switch (col.filterTemplate) {
              @case ('multiSelectFilterTemplate') {
                <p-columnFilter
                  matchMode="in"
                  [field]="col.field"
                  [showClearButton]="false"
                  [showMenu]="false"
                  >
                  <ng-template
                    let-filter="filterCallback"
                    let-value
                    pTemplate="filter"
                    >
                    <p-multiSelect
                      appendTo="body"
                      placeholder="Filter"
                      styleClass="p-column-filter"
                      [ngModel]="value"
                      [options]="col.filterList"
                      (onChange)="filter($event.value)"
                      >
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              }
              @default {
              }
            }
          </th>
        }
      </tr>
    }
  </ng-template>
  <ng-template let-columns="columns"  let-rowData pTemplate="body">
    <tr [pSelectableRow]="rowData">
      @if (multiselect) {
        <td style="width: 3.5rem">
          <p-tableCheckbox [value]="rowData" (click)="$event.stopPropagation()" />
        </td>
      }
      @for (col of columns; track $index) {
        <td>
          @switch (col.field) {
            @default {
              {{ rowData[col.field] }}
            }
          }
        </td>
      }
    </tr>
  </ng-template>
  <ng-template let-columns pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + 1">No records found.</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft">
    <!-- empty but allows paginator to be pushed to the right -->
  </ng-template>
</p-table>

@if (selection.length === 1) {
  <p-panel styleClass="mt-8" [toggleable]="true" toggler="header" [collapsed]="false">
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
      </ng-template>
      <ng-template #header>
        <div class="flex flex-auto justify-between items-center">
          <div>
            <span>Product Lines: </span>
            <span class="text-primary"
              >{{ activeCase?.category }} Case - {{ activeCase.caseNumber }}</span
              >
            </div>
          </div>
        </ng-template>
      <mnc-product-lines-selection
        [filterable]="filterable"
        [lines]="lines"
        [sortable]="sortable"
        (linesSelected)="handleLinesSelected($event)"
        />
  </p-panel>
    }
